import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import gordon from '../../Assets/Img/gordon.jpg'

const Chap32 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap31">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap33">Next</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 32: Denying Past Mormon Teachings</h1>

      <img src={gordon} className='image' alt='Mormon prophet Gordon Hinkley with Larry King' />

    <div className="wrapper">


    <div className='paragraph'>
          <p>Whereas Joseph claimed direct, visible communications with God, Christ, and angelic ministers, in 2004 Mormon prophet Gordon 
            Hinckley claimed revelation for the church came through vague impressions. Gordon revealed this in a TV interview with Larry 
            King.
            <btn id="clickable1" className="footnote">1 </btn>
             <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>CNN Larry King Live, Conversation with Gordon B. Hinckley, December 26, 2004.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>KING: You are the prophet, right?
          </p>
        </div>

        <div className='paragraph'>
          <p>HINCKLEY: Right.
          </p>
        </div>

        <div className='paragraph'>
          <p>KING: Does that mean that, according to the church canon, the Lord speaks through you?
          </p>
        </div>

        <div className='paragraph'>
          <p>HINCKLEY: I think he makes his will manifest, yes.
          </p>
        </div>

        <div className='paragraph'>
          <p>Prophet, seer, and revelator Gordon Hinckley “thinks he makes his will manifest?”
          </p>
        </div>

        <div className='paragraph'>
          <p>KING: So, if you change things, that’s done by an edict given to you.
          </p>
        </div>

        <div className='paragraph'>
          <p>HINCKLEY: Yes, sir.
          </p>
        </div>

        <div className='paragraph'>
          <p>KING: How do you receive it?
          </p>
        </div>

        <div className='paragraph'>
          <p>HINCKLEY: Well, various ways. It isn’t necessarily a voice heard. Impressions come. The building of this very building [referring to the newly built conference center] I think is an evidence of that.
          </p>
        </div>

        <div className='paragraph'>
          <p>Wait! No voice? I was taught as an impressionable boy that Jesus not only speaks to these men, but he appears to them. Continuing.
          </p>
        </div>

        <div className='paragraph'>
          <p>HINCKLEY: There came an impression, a feeling, that we need to enlarge our facilities where we could hold our conferences. And it was a very bold measure. We had to tear down a big building here and put this building up at great cost ... It is an answer to many, many needs. And I think it’s the result of inspiration.
          </p>
        </div>

        <div className='paragraph'>
          <p>KING: And that came from something higher than you.
          </p>
        </div>

        <div className='paragraph'>
          <p>HINCKLEY: I think so.
          </p>
        </div>

        <div className='paragraph'>
          <p>Gordon Hinckley also said this in an interview with Mike Wallace of CBS’ 60 Minutes, as reported by Don Lattin, Chronicle 
            Religion Writer at SF Gate.
            <btn id="clickable2" className="footnote">2 </btn>
             <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>Don Lattin, San Francisco Chronicle Religion Writer, SF Gate, April 13, 1997.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>“Q: And this belief in contemporary revelation and prophecy? As the prophet, tell us how that works. How do you receive divine revelation? What does it feel like?” 
          </p>
        </div>

        <div className='paragraph'>
          <p>“A: Let me say first that we have a great body of revelation, the vast majority of which came from the prophet Joseph Smith. We don’t need much revelation.”
          </p>
        </div>

        <div className='paragraph'>
          <p>We don’t need much revelation? As the 9th Article of Faith states, “… we believe that he will yet reveal many great and 
            important things pertaining to the Kingdom of God.”
            <btn id="clickable3" className="footnote">3 </btn>
             <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Ninth Article of Faith.</Tooltip>

            Continuing.
          </p>
        </div>

        <div className='paragraph'>
          <p>Again, no voice of Christ? No appearance of angels or the Father and Son? Just a vague impression? Continuing. 
          </p>
        </div>

        <div className='paragraph'>
          <p>“I liken it to Elijah’s experience. When he sought the Lord, there was a great wind, and the Lord was not in the wind. And there was an earthquake, and the Lord was not in the earthquake. And a fire, and the Lord was not in the fire. But in a still, small voice. Now that’s the way it works.”
          </p>
        </div>

        <h2 className="headlinePadding" >Don’t Know that We Teach It</h2>
        
        <div className='paragraph'>
          <p>In an interview with Time Magazine, Gordon Hinckley was asked, “‘As man is now, God once was, as God now is, man may become.’ 
            God the Father was once a man as we are. This is something that Christian writers are always addressing. Is this the teaching 
            of the church today, that God the Father was once a man like we are?” The prophet’s answer? “I don’t know that we teach it. 
            I don’t know that we emphasize it. I haven’t heard it discussed for a long time in public discourse. I don’t know. I don’t know 
            all the circumstances under which that statement was made. I understand the philosophical background behind it, but I don’t 
            know a lot about it, and I don’t think others know a lot about it.”
            <btn id="clickable4" className="footnote">4 </btn>
             <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Time Magazine, August 4, 1997.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>A man claiming to be the Mormon Prophet of God responded, “I Don’t Know?” This raises the question: do today’s Mormon 
            leaders even believe that Joseph was a prophet? Since the turn of the 20th century, Mormon leaders have changed or discarded 
            many of Joseph’s doctrines and teachings to keep pace with popular opinion.
            <btn id="clickable5" className="footnote">5 </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Charles R. Harrell, This Is My Doctrine: The Development of Mormon Theology, August 2011.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Gordon Hinckley’s response created concern among church members. He stated in general conference, “I personally have been 
            much quoted, and in a few instances misquoted and misunderstood … None of you need worry because you read something that was 
            incompletely reported. You need not worry that I do not understand some matters of doctrine.”  
            <btn id="clickable6" className="footnote">6 </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Gordon Hinckley, October 1997 General Conference.</Tooltip>
            This is known as blame the 
            messenger! Leaving the impression that the reporter misunderstood him.
          </p>
        </div>

        <div className='paragraph'>
          <p>The idea of man becoming a God was central to Joseph’s Mormonism. This is the grand and fundamental principle that needed 
            to be restored in the last days. It is the purpose of the temple, which is to make men kings and priests and women queens 
            and priestesses, and eventually gods to receive Christ at his Second Coming to rule with him during the Millennium. In his 
            King Follett discourse, Joseph preached, “God Himself was once as we are now, and is an exalted man, and sits enthroned in 
            yonder heavens!” Joseph added, “I say, if you were to see Him today, you would see Him like a man in form – like yourselves 
            in all the person, image, and very form as a man.”  
            <btn id="clickable7" className="footnote">7 </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>King Follett Sermon, April 7, 1844, Nauvoo, Illinois.</Tooltip>

            Then Joseph went on to explain how men and women could become as the Gods and join the endless chain of life-generating, creative beings.
          </p>
        </div>

        <div className='paragraph'>
          <p>Because it is controversial, the doctrine of becoming a God and the path of eternal exaltation are the most watered-down 
            and ignored of Joseph’s teachings.  
            <btn id="clickable8" className="footnote">8 </btn>
            <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Doctrine and Covenants 132, King Follet Discourse.</Tooltip>

            The church’s essay “Becoming Like God” states, “Latter-day Saints’ doctrine of exaltation is often similarly reduced in 
            media to a cartoonish image of people receiving their own planets ... while few Latter-day Saints would identify with 
            caricatures of having their own planet, most would agree that the awe, inspired by creation hints at our creative potential 
            in the eternities.”
            <btn id="clickable9" className="footnote">9 </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>"Becoming Like God," Gospel Topics Essays.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Today, besides brief mentions of a person’s divine potential in general conference and church manuals, there is virtually 
            nothing taught about the particulars of the path of eternal progression. You can find these things by reading early church 
            leaders. But church members are discouraged from searching out these things and they are to keep their eye squarely on the 
            current prophet and leaders.
            <btn id="clickable10" className="footnote">10 </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>Ezra Taft Benson, Fourteen Fundamentals in Following the Prophet, February 26, 1980.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding" >Joseph’s Remarkable Teachings </h2>

        <div className='paragraph'>
          <p>Differentiating from the Christian religions of his day, Joseph taught the possibility of the perfection of the human 
            personality. According to Joseph, it was the point of eternal life as ordained by God. “Here, then is eternal life – to 
            know the only wise and true God; and you have got to learn how to be Gods yourselves, and to be kings and priests to God, 
            the same as all Gods have done before you.” 
            <btn id="clickable11" className="footnote">11 </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Joseph Smith, Teachings of the Prophet Joseph Smith, p. 346.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Christianity, throughout the centuries, defined salvation as synonymous with eternal life. Joseph made eternal life 
            synonymous with becoming a God. To the Christian religions, only God and the Son could be considered perfect. Their 
            station was above and beyond simple humankind – you and me. Joseph, on the other hand, taught that a person could become 
            partakers of the divine nature by “partaking of the fulness of the Father and Son, through the spirit.”  
            <btn id="clickable12" className="footnote">12 </btn>
            <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Doctrine and Covenants, 1835 version, The Joseph Smith Papers, 52.</Tooltip>

            “That which is of God is light; and he that receiveth light, and continueth in God, receiveth more light; and that light 
            groweth brighter and brighter until the perfect day.”
            <btn id="clickable13" className="footnote">13 </btn>
            <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>D&C 50:24.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>For Joseph, this meant humankind could inherit glory, dominion, exaltation, thrones and every power and attribute 
            developed and possessed by God. This potential in men and women was seeds, nurtured by light and truth across time and 
            space, that would sprout into God-like qualities. This “becoming” principle involved mastering divine mysteries and acquiring 
            divine priesthood power. Joseph stated, “… A man can do nothing for himself unless God directs him in the right way; 
            and the Priesthood is for that purpose.”  
            <btn id="clickable14" className="footnote">14 </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Joseph Smith Sermon delivered at Nauvoo temple grounds on Friday May 12, 1844, Thomas Bullock report.</Tooltip>
            
            Joseph also taught, “The nearer man approaches perfection, the clearer are his views, and the greater his enjoyments, 
            till he has overcome the evils of his life and lost every desire for sin; and like the ancients, arrives at that point of 
            faith where he is wrapped in the power and glory of his Maker and is caught up to dwell with Him.” 
            <btn id="clickable15" className="footnote">15 </btn>
            <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Teachings of the Prophet Joseph Smith, 51.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Instead, in modern Mormonism we hear bumper sticker slogans, “follow the prophet.” “Repentance is a daily activity.” “Let 
            God prevail.” Grab the “iron rod” of doctrinal authority.  
            <btn id="clickable16" className="footnote">16 </btn>
            <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Thomas Alexander, “Historiography and the New Mormon History: A Historian’s Perspective,” Dialogue 19 (Fall 1986), 25-49; and Boyd Packer, “The Mantle if Far, Far Greater than the Intellect,” BYU Studies 21 (Summer 1981), 259-78.</Tooltip>
            
            Joseph encouraged his followers, “Thy mind … must stretch as high as the utmost Heavens, and search into and contemplate 
            the lowest considerations of the darkest abyss and expand upon the broad considerations of eternal expanse; he must commune 
            with God.”  
            <btn id="clickable17" className="footnote">17 </btn>
            <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>Dean C. Jessee and John W. Welch, “Revelations in Context: Joseph Smith’s Letter from Liberty Jail, March 20, 1839,” BYU Studies 39, no. 3 (2000): 137.</Tooltip>

            Sadly, these inspiring ideas are nowhere in the general conception of Mormonism today. Could that be why Mormons are dwindling in unbelief? Today, a Mormon is not encouraged to yearn to understand the mysteries of Godhood. They may believe they carry the seeds of divinity within them, and it is their birthright based on their valiancy in a premortal existence that they will one day be like God. But nothing more than that. Remember, leave the mysteries alone. 
          </p>
        </div>

        <div className='paragraph'>
          <p>In Mormonism today, there is no real encouragement to partake of the divine nature to the level that Joseph spoke of in a transformational process. Occasionally you will hear of the “enabling power of the atonement” in the context of overcoming personal weaknesses. But there is no real emphasis on Christ’s message in the New Testament and even the Book of Mormon on “redemption.” Spiritual transformation, the new birth of sinful humanity, the promised salvation are absent. Today Mormons are taught a merit-based, works-focused, life-long loyalty-to-the-church commitment that will lead to exaltation, earn a place in a celestial kingdom where you can be with your families forever. 
          </p>
        </div>

        <div className='paragraph'>
          <p>The turn of the 20th century marked the beginning of the end of Joseph’s mystical and mythical elements, which ignited a fire in his converts. Mormons of his day would suffer and die for Joseph’s religion. Today’s Mormons let out a sigh of relief when two-hour church was announced.
          </p>
        </div>

        <div className='paragraph'>
          <p>Even more tragic is today’s Mormonism 3.0. In this second dumbing down since the turn of the 20th century, Mormon leaders are 
            hiding even more history and publishing a correlated curriculum at the primary lesson for children. One manual for all 
            church members. Joseph, on the other hand, taught, “If thou shalt ask, thou shalt receive revelation upon revelation, 
            knowledge upon knowledge, that thou mayest know the mysteries.”  
            <btn id="clickable18" className="footnote">18 </btn>
            <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>D&C 42:61.</Tooltip>
            
            And that a person with the priesthood has, “The power and authority … To have the privilege of receiving the mysteries 
            of the kingdom of heaven, to have the heavens opened unto them … to enjoy the communion and presence of God the Father.”
            <btn id="clickable19" className="footnote">19 </btn>
            <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>D&C 107:18-19.</Tooltip>
          </p>
        </div>

        </div>

      <div className="chapterFooter">
        <Link to="/Chap31">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap33">Next</Link>
      </div>

    </div>
  )
}

export default Chap32